import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'convertConfig'
})
export class ConvertConfigPipe implements PipeTransform {

    transform(data: any, args?: any): any {
        if (data === "control_ip") {
            return "IP Control";
        } else if (data === "evaluation_weight") {
            return "weight_evaluation";
        } else if (data === "average_approval") {
            return "passing_average";
        } else if (data === "auto_sync") {
            return "operates_online";
        } else if (data === "show_question_without_response") {
            return "show_unanswered_questions";
        } else return data;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/pipe/convert-config.pipe.ts